import { sendGAEvent } from "@next/third-parties/google";

/**
 * sendGAEvent를 안전하게 호출하는 래퍼.
 *
 * @next/third-parties의 <GoogleAnalytics />가 주입하는 GA 초기화 스크립트는
 * afterInteractive 전략으로 로드된다. 그래서 페이지 마운트 직후 useEffect에서
 * sendGAEvent를 호출하면 window.dataLayer가 아직 생성되지 않아
 * "GA dataLayer dataLayer does not exist" 경고가 뜨고 이벤트가 유실될 수 있다.
 *
 * 호출 전에 dataLayer를 미리 초기화하면(GA 초기화 스크립트도 `|| []`를 쓰므로
 * 큐가 보존됨) 경고가 사라지고 이벤트도 안전하게 큐잉된다.
 */
export function sendGAEventSafe(
  ...args: Parameters<typeof sendGAEvent>
): void {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
  }
  sendGAEvent(...args);
}
